import {
  Component,
  OnInit,
  HostBinding,
  Input,
  ElementRef,
  AfterViewInit,
} from '@angular/core';

@Component({
  selector:
    'pg-form-col, [col], [pgFormColumn], grit-form-col, [gritFormColumna]',
  templateUrl: './pg-form-col.component.html',
  styleUrls: ['./pg-form-col.component.scss'],
})
export class PgFormColComponent implements OnInit, AfterViewInit {
  @HostBinding('class.col-sm-12')
  @Input()
  responsiveAtSmallestViewport = true;

  @HostBinding('class.col-sm')
  _classColSm = true;

  @HostBinding('class.col-md')
  _classColMd = true;

  @Input()
  get colWidth() {
    return this._colWidth;
  }
  set colWidth(value: number) {
    if (this.elementRef && this.elementRef.nativeElement) {
      this.elementRef.nativeElement.classList.remove(
        `col-md-${this._colWidth}`
      );
    }
    this._colWidth = value;
    if (this.elementRef && this.elementRef.nativeElement) {
      this.elementRef.nativeElement.classList.add(`col-md-${this._colWidth}`);
    }
  }
  protected _colWidth: number;

  constructor(public elementRef: ElementRef) {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.elementRef.nativeElement.classList.add(`col-md-${this._colWidth}`);
  }
}
